var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktokIconWhite = function SvgTiktokIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: "tiktok-icon-white_svg__bi tiktok-icon-white_svg__bi-tiktok",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"
  })));
};
export { SvgTiktokIconWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgY2xhc3M9ImJpIGJpLXRpa3RvayIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBkPSJNOSAwaDEuOThjLjE0NC43MTUuNTQgMS42MTcgMS4yMzUgMi41MTJDMTIuODk1IDMuMzg5IDEzLjc5NyA0IDE1IDR2MmMtMS43NTMgMC0zLjA3LS44MTQtNC0xLjgyOVYxMWE1IDUgMCAxIDEtNS01djJhMyAzIDAgMSAwIDMgM3oiLz4KPC9zdmc+";